import axios from 'axios'
import {APIHOST} from "@/settings";
import SessionStorage from "sessionstorage";

class ParseService {
    parse(base64Content) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.post(`${APIHOST}/api/Parser`, {
            ContentBase64String: base64Content
        }, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }
}

export default new ParseService();